import { render, staticRenderFns } from "./PlatNotice.vue?vue&type=template&id=3720204c&scoped=true"
import script from "./PlatNotice.vue?vue&type=script&lang=js"
export * from "./PlatNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3720204c",
  null
  
)

export default component.exports